module.exports = __webpack_public_path__ + "img/ИФ-1(А)-047.4880dfc1.png";